import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=6ca6103d&scoped=true"
import script from "./ResultDetail.vue?vue&type=script&lang=js"
export * from "./ResultDetail.vue?vue&type=script&lang=js"
import style0 from "./ResultDetail.vue?vue&type=style&index=0&id=6ca6103d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca6103d",
  null
  
)

export default component.exports